export default "Optimisation air comprimé — Fiche CEE IND-UT-117 | Solution Éco France";
